// extracted by mini-css-extract-plugin
export default {"container":"FileDetail_container__b02SZ","content":"FileDetail_content__kFhBO"};